export const sendMetriс = (type, value) => {
    window.ym(93218754, type, value)
  }
  